import React, { memo, useCallback, useRef, useState } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { Text } from '@Sage/hoi-poi-ui';

const DesignOption = memo(({ title, description, animation, textColor }) => {
    const playerRef = useRef(null);
    const lottieRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);

    const moveToIdleFrame = useCallback(() => {
        const totalFrames = lottieRef.current?.totalFrames;
        const firstFrame = lottieRef.current?.firstFrame || 0;

        if (!totalFrames || !lottieRef.current) return;

        const middleFrame = Math.max(firstFrame + Math.floor((totalFrames - 1) / 2), 0);

        lottieRef.current.goToAndStop(middleFrame, true);
    }, []);

    const handleMouseEnter = useCallback(() => {
        setIsHovered(true);
        playerRef.current?.play();
    }, []);

    const handleMouseLeave = useCallback(() => {
        setIsHovered(false);
        playerRef.current?.stop();
        moveToIdleFrame();
    }, [moveToIdleFrame]);

    const handlePlayerEvent = useCallback(
        (event) => {
            if (event === 'load' || event === 'ready' || (!isHovered && event === 'complete')) {
                moveToIdleFrame();
            }
        },
        [isHovered, moveToIdleFrame],
    );

    return (
        <div
            className="marketing-campaigns__design-form-option"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="marketing-campaigns__design-form-option-icon">
                <Player
                    ref={playerRef}
                    lottieRef={(instance) => {
                        lottieRef.current = instance;
                    }}
                    src={animation}
                    loop={isHovered}
                    onEvent={handlePlayerEvent}
                    keepLastFrame
                    className="marketing-campaigns__design-form-option-lottie"
                />
            </div>
            <div className="marketing-campaigns__design-form-option-copy">
                <Text
                    type="subtitle"
                    medium
                    className="marketing-campaigns__design-form-option-title"
                >
                    {title}
                </Text>
                <Text type="caption" color={textColor}>
                    {description}
                </Text>
            </div>
        </div>
    );
});

DesignOption.displayName = 'DesignOption';

export default DesignOption;
